import { render, staticRenderFns } from "./WineProductDescription.vue?vue&type=template&id=0a5001ae&scoped=true"
import script from "./WineProductDescription.vue?vue&type=script&lang=js"
export * from "./WineProductDescription.vue?vue&type=script&lang=js"
import style0 from "./WineProductDescription.vue?vue&type=style&index=0&id=0a5001ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5001ae",
  null
  
)

export default component.exports